import { render, staticRenderFns } from "./public-contact-card.vue?vue&type=template&id=ce192e4c&scoped=true&"
import script from "./public-contact-card.ts?vue&type=script&lang=ts&"
export * from "./public-contact-card.ts?vue&type=script&lang=ts&"
import style0 from "./public-contact-card.scss?vue&type=style&index=0&id=ce192e4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce192e4c",
  null
  
)

export default component.exports